export default __webpack_public_path__ + "static/media/image_31-900.c89d560d.png";